<section :aria-label="$t('cci_section_bar_title')" class="section-container" id="sections-bar" @mousedown="$store.commit('setShowOverlay', true)" @mouseup="$store.commit('setShowOverlay', false)" :aria-hidden="showArticleModal || showIssueOverview">
  <div role="link" tabindex="0" id="skip-section-bar" class="skip-link" @click="skipToMainContent()" @keydown.enter="skipToMainContent()">{{ $t('cci_skip_link_main') }}</div>
  <h2 class="announce" id="section-bar-heading">{{ $t('cci_section_bar_title') }}</h2>
  <div id="section-swiper-container" class="section-swiper-container">
    <button tabindex="0" :title="$t('cci_section_nav_prev')" class="section-nav-button section-nav-prev-button"
    id="section-nav-prev-button">
      <svg version="1.1" class="section-nav-icon" id="section-nav-prev-icon" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 37" xml:space="preserve">
        <rect x="0" y="0" transform="matrix(-1 -4.038160e-11 4.038160e-11 -1 20 37)" class="st0" width="20" height="37" />
        <polyline class="st1" points="14,12 6,20 14,28 " />
      </svg>
    </button>
  
    <div class="section-swiper-wrapper">
      <cci-section @vue:mounted="sectionMounted" @inFocus="itemInFocus" v-for="(section, index) in sections" :index="index" :section="section" :key="section.id" :ref="section.id"></cci-section>
    </div>

    <button tabindex="0" :title="$t('cci_section_nav_next')" class="section-nav-button section-nav-next-button"
        id="section-nav-next-button">
      <svg version="1.1" class="section-nav-icon" id="section-nav-next-icon" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 37" xml:space="preserve">
        <rect x="0" y="0" transform="matrix(-1 -4.038160e-11 4.038160e-11 -1 20 37)" class="st0" width="20" height="37" />
        <polyline class="st1" points="6,12 14,20 6,28 " />
      </svg>
    </button>
  </div>
</section>
